/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorissuenodishes4Inputs */

const en_menueditorissuenodishes4 = /** @type {(inputs: Menueditorissuenodishes4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter at least one dish.`)
};

const de_menueditorissuenodishes4 = /** @type {(inputs: Menueditorissuenodishes4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trag mindestens ein Gericht ein.`)
};

/**
* | output |
* | --- |
* | "Enter at least one dish." |
*
* @param {Menueditorissuenodishes4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorissuenodishes4 = /** @type {((inputs?: Menueditorissuenodishes4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorissuenodishes4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorissuenodishes4(inputs)
	return de_menueditorissuenodishes4(inputs)
});
export { menueditorissuenodishes4 as "menuEditorIssueNoDishes" }